import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private storedRoutes: { [key: string]: DetachedRouteHandle } = {};

  // Determina si una ruta debe ser guardada en caché
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return route.routeConfig?.path === 'estadocuenta'; // Guarda solo la ruta 'estadocuenta'
  }

  // Guarda la instancia del componente
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    if (route.routeConfig) {
      this.storedRoutes[route.routeConfig.path!] = handle!;
    }
  }

  // Determina si una ruta debe ser reutilizada
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return !!route.routeConfig && !!this.storedRoutes[route.routeConfig.path!];
  }

  // Recupera la ruta almacenada
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (!route.routeConfig || !this.storedRoutes[route.routeConfig.path!]) {
      return null;
    }
    return this.storedRoutes[route.routeConfig.path!];
  }

  // Determina si una ruta debe ser reutilizada
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}